import { Briefcase, Users } from 'lucide-react'
import { motion } from 'framer-motion'

const Experts = () => {
  return (
    <div className="pt-24 pb-16">
      <div 
        className="text-white py-20 mb-12 relative overflow-hidden bg-cover bg-center"
        style={{ backgroundImage: 'url("/images/experts-banner.png")' }}
      >
        {/* Overlay for readability */}
        <div className="absolute inset-0 bg-cidh-blue/80"></div>
        <div className="container mx-auto px-4 md:px-6 text-center relative z-10">
          <h1 className="text-3xl md:text-5xl font-bold font-montserrat mb-4 tracking-tight">Nos Experts & Consultants</h1>
          <p className="max-w-2xl mx-auto opacity-90 font-light text-lg">
            CIDH Consulting dispose de plus de 70 experts dans leurs différents domaines d'expertises pour répondre à vos exigences les plus pointues.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 md:px-6 mb-16">
        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-gray-100 max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
            <div className="md:col-span-8 space-y-6 text-gray-600 text-lg leading-relaxed">
              <p>
                Dirigé par une équipe rompue aux techniques de renforcement de capacité et de développement communautaire, le Centre dispose de plus de <span className="font-bold text-cidh-blue">70 formateurs</span>, experts seniors et juniors tous titulaires au minimum d'un <span className="font-bold text-cidh-blue">Master 2 (BAC+5)</span>, de diplômes d'ingénieurs, de Doctorats (Docteurs-ingénieurs, 3è cycle, d’Etat, Ph. D.), jouissant d’une expertise avérée en matière d’appui au développement.
              </p>
              <div className="h-px bg-gray-100 w-full"></div>
              <p>
                Parmi ceux-ci, <span className="font-bold text-cidh-gold">40</span> interviennent de manière permanente au Cabinet dans le cadre de l’élaboration, le suivi de projets et le renforcement des capacités dans des entreprises et structures de développement communautaire (Collectivités, Mutuelles de développement, Conseils régionaux, Organismes internationaux, …).
              </p>
            </div>
            <div className="hidden md:block md:col-span-4 translate-x-4">
              <div className="relative">
                <div className="absolute inset-0 bg-cidh-gold/20 rounded-full blur-3xl -z-10 animate-pulse"></div>
                <Users size={200} className="text-cidh-blue/5 mx-auto" strokeWidth={0.5} />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center">
                  <span className="block text-6xl font-bold text-cidh-gold">70+</span>
                  <span className="block text-xs uppercase font-bold text-cidh-blue tracking-widest mt-2">Experts</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Experts
